import React, { useMemo, useCallback } from 'react';
import JoditEditor from 'jodit-react';

const TextEditor = React.memo(({ value, onChange, onBlur }) => {
  // Memoize the config object so it's not recreated on every render
  const config = useMemo(() => ({
    readonly: false,
    placeholder: "",
    toolbarSticky: false,
    toolbarButtonSize: "medium",
    "buttons": "paragraph,|,brush,|,bold,italic,underline,strikethrough,|,link,source,|,ul,ol,|,fontsize",
    "buttonsMD": "paragraph,|,brush,|,bold,italic,underline,strikethrough,|,link,source,|,ul,ol,|,fontsize",
    "buttonsSM": "paragraph,|,brush,|,bold,italic,underline,strikethrough,|,link,source,|,ul,ol,|,fontsize",
    "buttonsXS": "paragraph,|,brush,|,bold,italic,underline,strikethrough,|,link,source,|,ul,ol,|,fontsize",
  }), []);

  // Memoize the onBlur handler
  const handleBlur = useCallback((newContent) => {
    if (onChange) {
      onChange(newContent);
    }
    
    // Call the onBlur callback if provided
    if (onBlur && newContent != value) {
      onBlur(newContent);
    }

  }, [onChange, onBlur]);

  return (
    <div className="jodit-editor text-break">
      <JoditEditor
        value={value}
        config={config}
        tabIndex={1}
        onBlur={handleBlur}
        onChange={onChange}
      />
    </div>
  );
});

export default TextEditor;
